import DualLinkCards from './DualLinkCards';
import React from 'react';

const DualLinkCardsWithProps = (props: any) => {
  return <DualLinkCards cards={props.cards} />;
};

export default DualLinkCardsWithProps;
